import React from "react"
import { motion } from "framer-motion"
import { Box } from "@chakra-ui/react"
import { TQR_CODE_CONFIG } from "./utils/config"

const MotionBox = motion.create(Box)

const TQRCodeCheckedIn = ({
  size = TQR_CODE_CONFIG.SIZE,
}: {
  size?: number
}) => (
  <MotionBox
    key="checked-in"
    width="100%"
    height="100%"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    boxSize={size}
    initial={{ scale: 1, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    exit={{ scale: 0, opacity: 0 }}
  >
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="checkedInGrad"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#27AE60" />
          <stop offset="50%" stopColor="#2ECC71" />
          <stop offset="100%" stopColor="#66D89E" />
        </linearGradient>
      </defs>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
        fill="url(#checkedInGrad)"
      />
    </svg>
  </MotionBox>
)

export default TQRCodeCheckedIn
